import {
  Divider,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { formatTimeStampToDate } from 'hooks/date/formattedTime'
import { useTranslation } from 'react-i18next'
import {
  ESubmissionSummaryProcurementSubmisionStatus,
  ETenderPaymentSummaryStatus,
  ITendersControlPanelSummary,
} from 'types/tender'

const StyledTable = styled(Table)(() => ({
  borderCollapse: 'collapse',
  width: '100%',
  '& th, & td': {
    border: '1px solid #dddddd !important',
  },
  '& th': {
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  '& .MuiTableCell-root': {
    paddingLeft: '12px',
    paddingRight: '12px',
  },
}))

type Props = {
  controlPanelSummary: ITendersControlPanelSummary
}

export const PriceProposalSummaryTable = ({ controlPanelSummary }: Props) => {
  const { t } = useTranslation()
  return (
    <>
      <Divider flexItem />
      <Typography variant="h6">{t('price-proposal')}</Typography>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer>
          <StyledTable
            size="small"
            sx={{ minWidth: 650, borderCollapse: 'collapse' }}
          >
            <TableHead>
              <TableRow>
                <TableCell>{t('supplier-name')}</TableCell>
                <TableCell>{t('date')}</TableCell>
                <TableCell>{t('status')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {controlPanelSummary.submissionSummary.procurementSubmissions.map(
                (proc, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell scope="row">{proc.organizationName}</TableCell>
                    <TableCell scope="row">
                      {proc.submittedAt
                        ? formatTimeStampToDate(proc.submittedAt)
                        : '-'}
                    </TableCell>
                    <TableCell scope="row">
                      {t(`procurement-proposal-summary-status-${proc?.status}`)}
                    </TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </Paper>
    </>
  )
}
